import { Trans, useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import SectionContainer from '~/landingV4/components/SectionContainer'
import TopicGroupRow from '~/landingV4/components/TopicGroupRow'
import { topicGroups } from '~/landingV4/consts/topics.const'
import { AppLanguage } from '~/types/locale'

export default function TopicsSection(): React.ReactElement {
  const { t } = useTranslation('abTestLanding')
  const router = useRouter()
  const isNorwegian = router.locale === AppLanguage.NO

  return (
    <section className="relative overflow-hidden bg-gradient-v4-topics">
      <SectionContainer className="flex flex-col items-center py-16 md:py-24">
        <div className="flex max-w-180 flex-col items-center gap-5 text-center">
          <h2 className="text-h3 font-extrabold text-white md:text-h2">{t('v4.topics.heading')}</h2>
          <p className="max-w-150 text-menu text-white/70">
            <Trans
              components={{ hand: <span className="font-hand text-[26px] text-green-lime" /> }}
              i18nKey="v4.topics.subtitle"
              t={t}
            />
          </p>
        </div>

        <div className="mt-14 flex w-full max-w-256 flex-col gap-8">
          {topicGroups.map((group) => (
            <TopicGroupRow group={group} key={group.badgeKey} />
          ))}
        </div>

        <div className="mt-24 flex max-w-180 flex-col items-center gap-4 text-center md:mt-32">
          <h2 className="text-h3 font-extrabold text-white md:text-h1">{t('v4.topics.neverStuckHeading')}</h2>
          <p className="text-menu text-white">{t('v4.topics.neverStuckText')}</p>
        </div>

        <div className="mx-auto mt-12 w-full max-w-180 md:mt-16">
          <ResponsiveImage
            alt=""
            className="w-full"
            height={1004}
            imageClassName="w-full"
            srcKey={isNorwegian ? 'landing/v4/quiz-no.png' : 'landing/v4/quiz-mobile.png'}
            width={1403}
          />
        </div>
      </SectionContainer>
    </section>
  )
}
